import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './locales/en'
import zh from './locales/zh'

Vue.use(VueI18n)

// 检测浏览器语言
function getDefaultLocale() {
  const userLanguage = navigator.language || navigator.userLanguage
  const supportedLocales = ['en', 'zh']
  
  // 检查是否是中文
  if (userLanguage.toLowerCase().includes('zh')) {
    return 'zh'
  }
  
  // 默认返回英文
  return 'en'
}

// 从localStorage获取保存的语言设置，如果没有则使用浏览器语言
const savedLocale = localStorage.getItem('dxf-viewer-locale')
const defaultLocale = savedLocale || getDefaultLocale()

const i18n = new VueI18n({
  locale: defaultLocale,
  fallbackLocale: 'en',
  messages: {
    en,
    zh
  }
})

export default i18n

// 导出切换语言的方法
export function changeLanguage(locale) {
  i18n.locale = locale
  localStorage.setItem('dxf-viewer-locale', locale)
  // 更新HTML lang属性
  document.documentElement.setAttribute('lang', locale)
  return locale
}

// 获取当前语言
export function getCurrentLanguage() {
  return i18n.locale
}

// 获取支持的语言列表
export function getSupportedLanguages() {
  return [
    { code: 'en', name: 'English', nativeName: 'English' },
    { code: 'zh', name: 'Chinese', nativeName: '中文' }
  ]
}
